//import ButtonMui from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
//import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { css } from 'styled-components';

export const LAYER_ACTION_HEIGHT = '368';

/**
 * Estilização do componente Wrapper
 */
export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1px;

  ${({ showRightOptions }) =>
    showRightOptions &&
    css`
      background: #e97575;
      transform: translateX(-50px);

      .right-swipeable-option {
        transform: translateX(50px);
      }
    `}

  .right-swipeable-option {
    background: #e97575;
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    padding: 8px 12px 8px 30px;
    z-index: -1;

    button {
      padding: 5px;
      margin: 0;
      border: none;
      background: transparent;

      svg {
        height: 14px;
        width: 14px;

        path {
          stroke: white;
          fill: white;
        }
      }
    }
  }

  .layer-item {
    min-height: 41px;
    width: 100%;
    padding: 13.5px 50px 12.5px 41.5px;
    background: white;

    @media (min-width: 768px) {
      &:hover {
        background: #D9E7FF;
      }
    }

    &.active {
      background: #D9E7FF;
;
      @media (min-width: 768px) {
        &:hover {
          background: #D9E7FF;
        }
      }
    }
    .left-addorn {
      position: absolute;
      top: 12px;
      left: 5px;

      .MuiCircularProgress-root {
        margin: 2px 7px;
      }

      button {
        background: none;
        border: none;
        color: #797e82;

        &:hover {
          color: #3c71dd;
        }

        &.disabled {
          color: #b6b6b6;

          &:hover {
            color: #3c71dd;
          }
        }
      }
    }

    .layer-content {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #5e6366;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .identification {
      color: #9DA5B6; 
      font-size: 10px;
      font-style: italic;
      font-weight: 400;
      
        &:hover {
          cursor: default;
        }

    }

    .right-addorn {
      position: absolute;
      top: 12.5px;
      right: 4px;

      .tooltipDisabled{
        pointer-events: none;
      }
      
      button {
        background: none;
        border: none;
        color: #797e82;

        &:hover {
          color: #3c71dd;
        }

        &.disabled {
          color: #b6b6b6;

          &:hover {
            color: #b6b6b6;
          }
        }
      }
    }
    .disabled {
      color: #b6b6b6;
    }
  }

  .layer-actions {
    height: LAYER_ACTION_HEIGHT + 'px';
    width: 47px;
    background: #f0f0f0;
    display: none;
    border-radius: 0px 3px 3px 0px;
    box-shadow: 0px -2px 7px rgba(0, 0, 0, 0.09);
    /* padding: 20px 6px 24px 6px; */
    padding: 20px 0px 24px 0px;
    text-align: center;    
    position: fixed;
    left: 256px;    
    top: ${({ heightEl, boundingTop, menuOutViewport }) => 
      (menuOutViewport && boundingTop-LAYER_ACTION_HEIGHT+heightEl + 'px') ||
      (!menuOutViewport && boundingTop + 'px')        
    }; 
    overflow: hidden;
    z-index: 1600;    

    &.active {
      display: block;        
      @media (max-width: 768px) {
        display: none;
      }
    }

    .layer-action {
      height: 36px;
      width: 100%;
      background: none;
      border: none;
      text-decoration: none;
      color: #797e82;

      .a-icon {
        margin-top: 3.5px;

        &.disabled {
          path {
            fill: #b6b6b6;
          }
        }
      }

      &:hover {
        color: #3c71dd;
        background: #ffffff;
      }

      .disabled {
        color: #b6b6b6;
      }

      .MuiSvgIcon-fontSizeSmall {
        font-size: 1rem;
      }
    }

    .cursorDefault {
      cursor: default;
    }

    .layer-action-active {      
      background: #ffffff;
    }

    .layer-action-current-active {
      color: #3c71dd;      
    }
  
}`;

/**
 * Estilização do componente MenuDowloader
 */
export const MenuDowloader = styled(Menu)`
  z-index: 1600 !important;

  .MuiMenu-paper {
    width: 174px;
    left: 251px;
    top: 213px;
    border-radius: 0px 2px 2px 0px;

    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    color: #5e6366;
  }

  .MuiList-padding {
    padding-top: 8px;
    padding-bottom: 16px;
    padding-right: 6px !important;
  }

  & .MuiPopover-paper {
    overflow-x: initial;
    overflow-y: initial;
  }

  & .MuiPaper-elevation8 {
    box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
  }

  & .title-content {
    width: 100%;
    padding: 17.34px 36px 0px 27px;

    hr {
      margin: 8px 0 0 0;
    }
  }

  & .item-content {
    width: 100%;

    .item-label {
      padding-left: 28px;

      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
    }

    svg {
      margin-right: 36px;
      margin-top: 4px;
      float: right;
    }
    
    p {
      padding-left: 30px;
      padding-right: 30px;
      margin-bottom: 0px;

      font-style: italic;
      font-weight: normal;
      font-size: 11px;
      line-height: 17px;
    }
  }
`;

/**
 * Estilização do componente StyledPopover
 */
export const Popup = styled(Popover)`
  z-index: 1600 !important;  

  .MuiPopover-paper {
    max-width: 700px;
    min-width: ${({ minWidth }) => (minWidth)};
    border-radius: 0;
    padding: ${({ padding }) => (padding)};   
    overflow-x: initial;
    overflow-y: initial;
    border-radius: 0px 2px 2px 0px;    
  }

  & .MuiPaper-elevation8 {
    box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
  }
`;